import * as React from 'react';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  DialogTitle,
  Dialog,
  Typography,
  Box,
  Tooltip,
} from '@mui/material';
import { blue } from '@mui/material/colors';
import PersonIcon from '@mui/icons-material/Person';
import AddIcon from '@mui/icons-material/Add';
import RealEstateAgentIcon from '@mui/icons-material/RealEstateAgent';
import { LogoutOutlined } from '@ant-design/icons';
import { useGetAngelProfileQuery, useGetClientIdStatusQuery} from '../../slices/usersApiSlice';
import { setAngelUserId,angelLogout } from '../../slices/angelAuthSlice';
import { useLogoutAngeloneMutation ,useGetAngelOrdersQuery,useGetAngeloneHoldingQuery,useGetAngelonePositionQuery, useGetAngelOrderPnlQuery, useConnectGrowwMutation} from '../../slices/angelOneApiSlice';
import { Link, useNavigate } from 'react-router-dom';
import { message, notification } from 'antd';
import angelone from "../../images/angelone.png";
import logoGroww from "../../images/logoGroww.png";
import { useDashboardCalculationMutation } from '../../slices/zerodhaApiSlice';
import { setCalculations } from '../../slices/dashboardSlice';
import { useGetGrowwLoginProfileQuery, useGetGrowwOrdersQuery, useGetGrowwProfileQuery ,useGetGrowwHoldingQuery, useGetGrowwPositionQuery, useGrowwOrderPnlQuery} from '../../slices/gowwApiSlices';
// const brokerNames = ['Angel One','groww'];
const brokerNames = [
  {
    name: "Angel One",
    code: "angelone",
    logo: angelone,
    apiKey: "6UMDn1Xl",
  },
  {
    name: "Groww",
    code: "groww",
    logo: logoGroww,
  },
];

function SimpleDialog(props) {
  const { userInfo } = useSelector((state) => state.auth);
const dispatch=useDispatch();
const navigate=useNavigate();
console.log(brokerNames.apiKey)
const userId = userInfo?._id || localStorage.getItem('userId');
console.log(userId,"userid");
const { onClose, selectedValue, open } = props;
// const{data:holdings}=useGetAngeloneHoldingQuery(userId);
// const{data:position}=useGetAngelonePositionQuery(userId);
const{data:ordersGroww}=useGetGrowwOrdersQuery();
console.log(ordersGroww);
const{data:growwProfile}=useGetGrowwProfileQuery();
console.log(growwProfile);
const {data:user}=useGetGrowwLoginProfileQuery();
console.log(user);
  const { data: angelProfile, error: angelError } = useGetAngelProfileQuery(userId);

const {data:growwholdings}=useGetGrowwHoldingQuery();
console.log(growwholdings);
const {data:growspositions}=useGetGrowwPositionQuery();
console.log(growspositions);
const{data:GrowwOrderPnl}=useGrowwOrderPnlQuery(userId);
console.log(GrowwOrderPnl);



const{data:pnl}=useGetAngelOrderPnlQuery(userId);
console.log("order pnl",pnl);
const{data:orders}=useGetAngelOrdersQuery(userId);
  // const [uploadCsv] = useUploadCsvMutation();

console.log("orders angelone",orders);
  const [api, contextHolder] = notification.useNotification();
  const { date } = useSelector((state) => state.date);

  const [dashboardCalculation, { isLoading: isCalculationLoading }] = useDashboardCalculationMutation();


 const getCalculations = async (startDate, endDate) => {
    try {
      const res = await dashboardCalculation({ startDate, endDate }).unwrap();
      console.log(res);

      dispatch(setCalculations({ ...res }));
    } catch (err) {
      console.log(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error || err?.data?.error
      });
    }
  }
  useEffect(() => {
    console.log(date.startDate,date.endDate);
    
    getCalculations(date.startDate, date.endDate);


    try {
      // const res = uploadCsv().unwrap();
      // console.log('Upload Success:', res);
      // alert('Orders uploaded successfully');
    } catch (err) {
      console.error('Upload Failed:', err);
      // alert('Error uploading orders');
    }
  }, [date])
const isGrowwConnected = growwProfile?.data?.active;
const isAngelOneConnected=angelProfile?.data?.name;
console.log(isGrowwConnected);;
console.log(isAngelOneConnected);


  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };
  const [connectGroww, { isLoading }] = useConnectGrowwMutation();
  const handleBrokerClick = async (broker) => {
      if (broker.code === "angelone") {

    const redirect = "https://app.lincfolio.com/api/api/v2/angelone/fallback";

    window.location.href =
      `https://smartapi.angelone.in/publisher-login?api_key=${broker.apiKey}` +
      `&redirect_url=${encodeURIComponent(redirect)}` +
      `&state=${userId}`;
  }

  // if (broker.code === "angelone") {
  //   window.location.href = 
  //     `https://smartapi.angelone.in/publisher-login?api_key=${broker.apiKey}&state=${userId}`;
  // }

  if (broker.code === "groww") {
    try {
      
    if (!isGrowwConnected) {
      message.warning("Groww API key required. Please add API key first.");
      return;
    }

      // const res = await connectGroww(userId).unwrap();
      // message.success("Groww connected successfully");
    } catch (err) {
      message.error(err?.data?.error || "Groww connection failed");
    }
  }
};



  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Connect to broker account.</DialogTitle>
      <List sx={{ pt: 0 }}>
  

{brokerNames.map((broker) => {
  // Determine connection status
  const isConnected =
    broker.code === "groww"
      ? isGrowwConnected
      : broker.code === "angelone"
      ? isAngelOneConnected // you'll need a state or check for Angel One
      : false;

  return (
    <ListItem disablePadding key={broker.code}>
      <ListItemButton
  // disabled={isConnected}
  onClick={() => !isConnected && handleBrokerClick(broker)}
>
      {/* <ListItemButton onClick={() => handleBrokerClick(broker)}> */}
        <ListItemAvatar>
          <Avatar sx={{ bgcolor: blue[100] }}>
            <img src={broker.logo} alt={broker.name} style={{ height: "40px" }} />
          </Avatar>
        </ListItemAvatar>

        <ListItemText
          primary={
            <Typography
              sx={{
                color: isConnected ? "#0dc019f3" : "inherit",
                fontWeight: isConnected ? 600 : 400,
              }}
            >
              {broker.name} {isConnected && "(Connected)"}
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  );
})}

        {/* <ListItem disablePadding>
          <ListItemButton autoFocus onClick={() => handleListItemClick('addAccount')}>
            <ListItemAvatar>
              <Avatar>
                <AddIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Add account" />
          </ListItemButton>
        </ListItem> */}
      </List>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

export default function AngelOneDialog({ open, onClose }) {
    const { userInfo } = useSelector((state) => state.auth);

const userId = userInfo?._id || localStorage.getItem('userId');
const clientId = userInfo?._id || localStorage.getItem('clientId');

  const dispatch =useDispatch();
    // const angelUserId = useSelector((state) => state.angelUser.angelUserId);
const navigate = useNavigate(); // 👈 for redirect

  // const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(brokerNames[0]);

  const [logoutAngelone] = useLogoutAngeloneMutation();
  const { data: angelProfile, error: angelError } = useGetAngelProfileQuery(userId);
  const { data: clientIdStatus, error, isLoading } = useGetClientIdStatusQuery(clientId);

 
  
const handleClickOpen = () => {
  if (true) {
    open(true); // ✅ Open dialog if clientId exists
  } else {
    message.warning('Please enter your Client ID to connect broker.');
    navigate('/profile'); // ❌ Redirect to profile
  }
};
//  const handleClose = (value) => {
//     setOpen(false);
//     setSelectedValue(value);
//   };
const handleClose = () => {
  onClose();
};
  const handleLogout = async () => {
    try {
      await logoutAngelone().unwrap();
            dispatch(angelLogout());
          alert("Logged out successfully");

      console.log("Logged out successfully");
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };
  return (
  <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
    {/* Only SimpleDialog is rendered */}
    <SimpleDialog
      selectedValue={selectedValue}
      open={open}
      onClose={handleClose}
    />
  </Box>
);}

//   return (
//   <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
//   {angelProfile?.data?.name ? (
//     <>
//       <Tooltip title="Logout">
//         <Link onClick={handleLogout} style={{ cursor: 'pointer',marginLeft:"8px",marginTop:"5px" }} >Logout..</Link>
//       </Tooltip>
//     </>
//   ) : (
//     // <Box onClick={handleClickOpen}   style={{color:"gray"}}>
//     //   Connect Broker  
//     //   <SimpleDialog selectedValue={selectedValue} open={open} onClose={handleClose} />
//     // </Box>
//     //  <Box
//     //     onClick={(e) => {
//     //       e.stopPropagation();
//     //       e.nativeEvent.stopImmediatePropagation();
//     //       handleClickOpen();
//     //     }}
//     //     style={{ color: "gray", width: "100%", cursor: "pointer" }}
//     //   >
       
//     //   </Box>
//     null
//     )}

//     {/* ✅ IMPORTANT: Dialog hamesha yaha rahega */}
//     <SimpleDialog
//       selectedValue={selectedValue}
//       open={open}
//       onClose={handleClose}
//     />

//   </Box>


//   );
// }


     
// {brokerNames.map((broker) => (
//   <ListItem disablePadding key={broker.code}>
//     {/* <ListItemButton
//       onClick={() => handleBrokerClick(broker)}
//     > */}
//     <ListItemButton
//   onClick={() => handleBrokerClick(broker)}
//   // disabled={broker.code === "groww" && isGrowwConnected}
// >

//       <ListItemAvatar>
//         <Avatar sx={{ bgcolor: blue[100] }}>
//           <img
//             src={broker.logo}
//             alt={broker.name}
//             style={{ height: "40px" }}
//           />
//         </Avatar>
//       </ListItemAvatar>

// <ListItemText
//   primary={
//     broker.code === "groww" ? (
//       <Typography
//         sx={{
// color: isGrowwConnected ? "#0dc019f3" : "inherit",
//           fontWeight: isGrowwConnected ? 600 : 400,
//         }}
//       >
//         {broker.name} {isGrowwConnected && "(Connected)"}
//       </Typography>
//     ) : (
//       broker.name
//     )
//   }
// />

//     </ListItemButton>
//   </ListItem>
// ))}




